var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("div", { staticClass: "logo" }, [
        _c("img", { class: _vm.navLogo, attrs: { src: _vm.logoUrl } })
      ]),
      _c(
        "el-menu",
        {
          staticClass: "left-menu",
          attrs: { router: true, mode: "horizontal" },
          on: { select: _vm.handSelect }
        },
        [
          _vm._l(_vm.routes, function(route, menuIndex) {
            return !(route.path === "/" || route.path === "/back")
              ? _c(
                  "el-popover",
                  {
                    key: route.id,
                    ref: "subMenuPop" + menuIndex,
                    refInFor: true,
                    attrs: { placement: "bottom", trigger: "click" },
                    model: {
                      value: route.isShowMenu,
                      callback: function($$v) {
                        _vm.$set(route, "isShowMenu", $$v)
                      },
                      expression: "route.isShowMenu"
                    }
                  },
                  [
                    _c("menuDetail", {
                      attrs: { route: route, "all-routes": _vm.routes },
                      on: { hiddenProver: _vm.hiddenProver }
                    })
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._l(_vm.routes, function(route, menuIndex) {
            return !_vm.isZqpt || route.path === "/back"
              ? _c(
                  "el-menu-item",
                  {
                    directives: [
                      {
                        name: "popover",
                        rawName: "v-popover",
                        value: "subMenuPop" + menuIndex,
                        expression: "'subMenuPop'+menuIndex"
                      }
                    ],
                    key: route.id,
                    staticClass: "active-text-color",
                    attrs: { index: _vm.getIndex(route, menuIndex) }
                  },
                  [
                    _c("template", { slot: "title" }, [
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleMenuActive(menuIndex)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.showName(route)))]
                      )
                    ])
                  ],
                  2
                )
              : _vm._e()
          })
        ],
        2
      ),
      _c("div", { staticClass: "right-menu" }, [
        _c(
          "div",
          { staticClass: "avatar-container right-menu-item" },
          [
            _c("img", {
              staticClass: "houtai-user",
              attrs: { src: _vm.userUrl }
            }),
            _c("div", { staticClass: "avatar-wrapper-name" }, [
              _vm._v(_vm._s(_vm.userName))
            ]),
            !_vm.isZqpt
              ? _c(
                  "el-dropdown",
                  {
                    staticStyle: { "margin-right": "0.3vw" },
                    attrs: { trigger: "click" }
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("svg-icon", {
                          staticClass: "theme-icon",
                          staticStyle: {
                            "font-size": "1.7vw",
                            color: "#fff",
                            "margin-right": "0.2vw",
                            "padding-top": "1.2vh"
                          },
                          attrs: { "icon-class": "theme" }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "theme-text",
                            staticStyle: {
                              color: "#fff",
                              "margin-right": "0.8vw",
                              cursor: "pointer"
                            }
                          },
                          [_vm._v("更换主题")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-dropdown-menu",
                      {
                        staticClass: "dropdow-menu-theme",
                        attrs: { slot: "dropdown" },
                        slot: "dropdown"
                      },
                      [
                        _c("el-dropdown-item", [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleThemeSet("")
                                }
                              }
                            },
                            [_vm._v("默认")]
                          )
                        ]),
                        _c("el-dropdown-item", [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.handleThemeSet("navyBlue")
                                }
                              }
                            },
                            [_vm._v("深蓝色主题")]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isZqpt && _vm.userTheme
              ? _c("img", {
                  staticClass: "logout",
                  staticStyle: { width: "1vw", "margin-right": "0.5vw" },
                  attrs: { src: "static/img/logout.png" }
                })
              : _vm._e(),
            !_vm.isZqpt
              ? _c(
                  "div",
                  { staticClass: "avatar-wrapper", on: { click: _vm.logout } },
                  [_vm._v(" 退出 ")]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }